export const GA_EVENT = {
  INTERACTION: 'interaction',
  VIEW: 'view',
  EVENT: 'event'
}

export const GA_ACTION = {
  INTERACTION: {
    DATE_PICKER: 'clicked get date picker',
    NUMBER_OF_TICKETS: 'clicked on number of tickets field',
    FIRST_NAME: 'clicked on first name field',
    LAST_NAME: 'clicked on last name field',
    EMAIL: 'clicked on email field',
    PHONE: 'clicked on phone field',
    SHOW_PREFERENCE: 'clicked on show preference',
    SHOW_TIME: 'clicked on show time',

    EXCLUDED_SHOW: 'clicked on show to exclude it',
    UNEXCLUDED_SHOW: 'clicked on show to unexclude it',

    DISCOUNT: 'clicked on discount field',

    CREDIT_CARD: 'clicked on credit card number field',
    EXPIRATION_MONTH: 'clicked on expiration month field',
    EXPIRATION_YEAR: 'clicked on expiration year field',
    CVC_CODE: 'clicked on cvc field',

    SUBMIT_PURCHASE: 'clicked to submit purchase',
    SUBMIT_PURCHASE_ACCOUNT_RESTAURANT_RESERVATION: 'clicked to submit purchase',
    SUBMIT_PURCHASE_GIFT_CARD: 'clicked to submit gift card purchase',
    SUBMIT_PURCHASE_SECOND_SPIN: 'clicked to submit second spin purchase',
    SUBMIT_PURCHASE_SUBSCRIPTION: 'clicked to submit subscription purchase',

    FAMILY_ROULETTE: 'clicked family roulette',
    PREMIUM_ROULETTE: 'clicked premium roulette',
    REGULAR_ROULETTE: 'clicked regular roulette',

    EXTRA_EXCLUSION: 'clicked to toggle extra exclusion',
    FAMILY_ROULETTE_EXCLUSION: 'clicked to toggle extra exclusion family roulette',
    NO_EXTRA_EXCLUSION: 'clicked no on extra exclusion',
    YES_EXTRA_EXCLUSION: 'clicked yes on extra exclusion',
    EXTENDED_HOURS: 'clicked to toggle extended hours',
    CANCEL_EXTENDED_HOURS: 'clicked cancel extended hours',
    NO_SPECIAL_SHOWS: 'clicked no on special shows',
    YES_SPECIAL_SHOWS: 'clicked yes on special shows',
    CLOSE_POPUP: 'clicked to close popup',

    YES_SECOND_SPIN: 'clicked yes to accept a second spin',
    NO_SECOND_SPIN: 'clicked no to reject a second spin',
    SHOW_TIME_SECOND_SPIN: 'clicked on show time on second spin page',
    DATE_PICKER_SECOND_SPIN: 'clicked get date picker on second spin page',

    RESTAURANT: 'clicked restaurant checkbox',
    RESTAURANT_YES_POPUP: 'clicked yes on restaurant popup',
    TICKETFLEX: 'clicked ticketflex checkbox',
    TICKETFLEX_YES_POPUP: 'clicked yes on ticketflex popup',

    ACCOUNT_RESTAURANT_RESERVATION_SUBMIT: 'clicked to add restaurant reservation on account page',

    SUBMIT_REFERRAL: 'entered email for referral',

    BUY_TICKETS_HEADER: 'clicked buy tickets in header',
    BUY_TICKETS_FOOTER: 'clicked buy tickets in footer',
    BUY_TICKETS_BUTTON: 'clicked buy tickets button',
    BUY_TICKETS_FAQ: 'clicked buy tickets button on FAQ page',
    BUY_TICKETS_ABOUT: 'clicked buy tickets button on about page',
    BUY_TICKETS_CURRENT_SHOWS: 'clicked buy tickets button on current shows page',
    BUY_TICKETS_SHOW: 'clicked buy tickets button on show page',
    BUY_TICKETS_GIFT: 'clicked buy tickets button on gift card page',
    BUY_TICKETS_HOW: 'clicked buy tickets button on how it works page',
    BUY_TICKETS_PRESS: 'clicked buy tickets button on press page',
    BUY_TICKETS_SUBSCRIPTION: 'clicked buy tickets button on subscription page',

    HOW_IT_WORKS_HEADER: 'clicked how it works in header',
    HOW_IT_WORKS_FOOTER: 'clicked how it works in footer',
    MONTHLY_SPIN: 'submitted email on monthly spin',
    FOOTER_SUBMIT: 'submitted email on footer input',
    SUBSCRIPTION_MAILING_SUBMIT: 'submitted email on subscription page',
    SUBSCRIBE_AND_SAVE_HEADER: 'clicked subscribe and save in header',

    FOOTER_PRESS_CLICK: 'clicked a footer press link',
    TODAYTIX_FAQ_LINK: 'clicked on TodayTix link in FAQ',

    GOOGLE_REVIEW_BUTTON: 'clicked to review us on google',
    YELP_REVIEW_BUTTON: 'clicked to review us on yelp',
  },
  VIEW: {
    EXCLUSION_POPUP: 'viewed extra exclusion popup',
    EXTENDED_HOURS_POPUP: 'viewed extended hours popup',
    RESTAURANT_POPUP: 'viewed restaurant popup',
    TICKETFLEX_POPUP: 'viewed ticketflex popup',
  },
  EVENT: {
    GIFT_CARD_ORDER_INVALID: 'evented on invalid order after submitting gift card purchase',
    PAYMENT_FAILED: 'evented on failed payment after submitting purchase',
    PAYMENT_SUCCEEDED: 'evented on successful payment after submitting purchase',
    PAYMENT_FAILED_SECOND_SPIN: 'evented on failed payment after submitting second spin purchase',
    PAYMENT_SUCCEEDED_SECOND_SPIN: 'evented on successful payment after submitting second spin purchase',
    PAYMENT_ACCOUNT_RESTAURANT_RESERVATION_FAILED: 'evented on successful payment after adding restaurant reservation',
    PAYMENT_ACCOUNT_RESTAURANT_RESERVATION_SUCCEEDED: 'evented on successful payment after adding restaurant reservation',
    PAYMENT_GIFT_CARD_FAILED: 'evented on successful payment after gift card',
    PAYMENT_GIFT_CARD_SUCCEEDED: 'evented on successful payment after gift card',
    PAYMENT_SUBSCRIPTION_FAILED: 'evented on successful payment after subscription purchase',
    PAYMENT_SUBSCRIPTION_SUCCEEDED: 'evented on successful payment after subscription purchase',
    ORDER_INVALID: 'evented on invalid order after submitting purchase',
    ORDER_INVALID_SECOND_SPIN: 'evented on invalid order after submitting second spin purchase',
    LOGIN_FAILURE: 'evented on login failure',
    RESTAURANT_RESERVATION_ADD_ON_ORDER_INVALID: 'evented on invalid order after submitting restaurant reservation add on purchase',
    SUBSCRIPTION_ORDER_INVALID: 'evented on invalid order after submitting subscription purchase'
  }
}

export const sendGAEvent = (event, action, message) => {
  if (process.env.REACT_APP_STAGE === 'PROD') {
   window.ga('send', 'event', event, action)

    var messageToSend = message ? { 'message': message } : null
    gtag('event', action, messageToSend)

  } else (
    console.log('would fire event: ' + event + ', action: ' + action)
  )
}

export const sendGAEcommerceEventsSpinPage = (orderId, numberOfTickets, pricing, requestedShowDate) => {
  if (process.env.REACT_APP_STAGE === 'PROD') {
    window.ga('ecommerce:clear')
    window.ga('ecommerce:addTransaction', {'id': orderId,'revenue': pricing.totalCost.toFixed(2)})
    var gtmProducts = []

    window.ga('ecommerce:addItem', {'id': orderId,
                                    'name': 'Tickets',
                                    'sku': 'tickets',
                                    'quantity': numberOfTickets,
                                    'price': pricing.totalCost.toFixed(2)
                                   })
    gtmProducts.push({
      'item_name': 'Ticket',
      'item_id': 'ticket',
      'price': pricing.totalCost.toFixed(2),
      'quantity': numberOfTickets,
      'item_variant': requestedShowDate
    })

    window.ga('ecommerce:send')

    window.dataLayer.push({
      'event': 'purchase',
      'ecommerce': {
        'items': gtmProducts
      }
    })
  } else (
    console.log('would fire ga buy tickets ecomm event')
  )
}

export const sendAdwordsConversion = (totalCost) => {
  if (process.env.REACT_APP_STAGE === 'PROD') {
    if (window.gtag_track_conversion) {
      console.log(`Reported conversion. Conversion value: ${totalCost}`)
      window.gtag_track_conversion(totalCost)
    }
  } else (
    console.log('would fire adword conversion')
  )
}

export const sendGAEcommerceEventsGiftCard = (orderId, totalCost) => {
  if (process.env.REACT_APP_STAGE === 'PROD') {
    window.ga('ecommerce:clear')
    window.ga('ecommerce:addTransaction', {'id': orderId,'revenue': totalCost})
    window.ga('ecommerce:addItem', {'id': orderId, 'name': 'Gift Card', 'sku':'gift-card', 'quantity': 1, 'price': totalCost})
    window.ga('ecommerce:send')

    window.dataLayer.push({
      'event': 'purchase',
      'ecommerce': {
        'items': [{
          'item_name': 'Gift Card',
          'item_id': 'gift-card',
          'price': totalCost,
          'quantity': 1
        }]
      }
    })

  } else (
    console.log('would fire ga gift card ecomm event')
  )
}

export const sendGAEcommerceEventsRestaurantAccount = (orderId, restaurantReservationFee) => {
  if (process.env.REACT_APP_STAGE === 'PROD') {
    window.ga('ecommerce:clear')
    window.ga('ecommerce:addTransaction', {'id': orderId,'revenue': restaurantReservationFee.toFixed(2)})
    window.ga('ecommerce:addItem', {'id': orderId,
                                    'name': 'Restaurant Reservation',
                                    'sku': 'restaurant-reservation',
                                    'quantity': 1,
                                    'price': restaurantReservationFee.toFixed(2)
                                   })
    window.ga('ecommerce:send')

    window.dataLayer.push({
      'event': 'purchase',
      'ecommerce': {
        'items': [{
          'item_name': 'Restaurant Reservation',
          'item_id': 'restaurant-reservation',
          'price': restaurantReservationFee.toFixed(2),
          'quantity': 1
        }]
      }
    })

  } else (
    console.log('would fire ga restaurant ecomm event')
  )
}

export const sendGAEcommerceEventsSubscription = (orderId, totalCost) => {
  if (process.env.REACT_APP_STAGE === 'PROD') {
    window.ga('ecommerce:clear')
    window.ga('ecommerce:addTransaction', {'id': orderId, 'revenue': totalCost})
    window.ga('ecommerce:addItem', {'id': orderId, 'name': 'Subscription', 'sku':'subscription', 'quantity': 1, 'price': totalCost})
    window.ga('ecommerce:send')

    window.dataLayer.push({
      'event': 'purchase',
      'ecommerce': {
        'items': [{
          'item_name': 'Subscription',
          'item_id': 'subscription',
          'price': totalCost,
          'quantity': 1
        }]
      }
    })

  } else (
    console.log('would fire ga subscription ecomm event')
  )
}

export const sendGA404PageHitEvent = () => {
  window.ga('send', { 'hitType': 'pageview', 'page': '/NotFoundPage', 'title': 'Not Found'})
  window.ga('send', {
    hitType: 'event',
    eventCategory: 'view',
    eventAction: 'Not Found Page',
    eventLabel: window.location.pathname
  })

  gtag('event', 'Not Found Page', {
    'pathname': window.location.pathname
  })
}

/* GA4 */
export const sendPurchaseGAEvent = (orderId, orderTotal, price, itemID, itemName, quantity, promoCode, discount) => {
  if (process.env.REACT_APP_STAGE === 'PROD') {
    console.log('purchase')

    gtag('event', 'purchase', {
      transaction_id: orderId,
      value: orderTotal,
      currency: 'USD',
      coupon: promoCode,
      items: [
       {
        item_id: itemID,
        item_name: itemName,
        affiliation: 'Broadway Roulette',
        coupon: promoCode,
        discount: discount,
        location_id: "ChIJOwg_06VPwokRYv534QaPC8g",
        price: price,
        quantity: quantity
      }]
    })

  } else (
    console.log(`would fire event: purchased, ${orderId}, ${orderTotal}, ${promoCode}`)
  )
}